import { DOCUMENT, effect, inject, Injectable } from '@angular/core';
import { UiStore } from '../../core/store/ui.store';

/**
 * Experimental dark mode (available only for superadmin for now).
 * Applies the theme mode from UiStore as a class on the <html> element.
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  private document = inject(DOCUMENT);
  private uiStore = inject(UiStore);

  constructor() {
    effect(() => {
      this.document.documentElement.classList.toggle('dark-theme', this.uiStore.themeMode() === 'dark');
    });
  }

  toggle() {
    this.uiStore.setThemeMode(this.uiStore.themeMode() === 'dark' ? 'light' : 'dark');
  }
}
